import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import ReportModelBase from '../ReportModelBase';
import { Table } from 'semantic-ui-react';

class EmployeeReportModelGroupByDepartment extends ReportModelBase {

    constructor(props){
        super(props);
        this.searchUrl = "api/Reports/employeeReportGroupByDepartment";
        this.title = "Employee Report Group by Department";
        this.exportToExcelUrl = "api/Reports/ExportEmployeeReportGroupByDepartmentToExcel";
        this.exportToPdfUrl = "api/Reports/ExportEmployeeReportGroupByDepartmentToPDF";
    }

    toTableRow = (rowData) => {
        return (
            <Table.Row>
                <Table.Cell>{rowData["Employee No"]}</Table.Cell>
                <Table.Cell>{rowData["Employee"]}</Table.Cell>
                <Table.Cell>{rowData["Department"]}</Table.Cell>
            </Table.Row>
        );
    }

    createColumnHeaders = () => {
        return (
            <Table.Row>
                <Table.HeaderCell>Employee No</Table.HeaderCell>
                <Table.HeaderCell>Employee</Table.HeaderCell>
                <Table.HeaderCell>Department</Table.HeaderCell>
            </Table.Row>
        );
    }

}
export default EmployeeReportModelGroupByDepartment;